const ShippingMethodService = function () {
    return {
        methods: [],
        /**
         * @param {ShippingMethod[]} methods
         * @returns {ShippingMethodService}
         */
        setMethods: function (methods) {
            this.methods = methods;
            return this;
        },

        /**
         * Matrix of WLEC-6499 reduced to minimum
         *
         * @see http://jira.wlec.ag:20304/browse/WLEC-6499
         *
         * @param {ShippingMethod} item
         * @param {Cart} Cart
         * @return (number)
         */
        getPrice: function (item, Cart) {
            if (!item) {
                return 0;
            }

            var ticketCost = 0;

            if (Cart && Cart.ticketFormat) {
                var rawTicketCost = Cart.ticketFormat.shippingcosts;

                if (rawTicketCost !== null && rawTicketCost !== undefined && rawTicketCost !== '') {
                    var tc = parseFloat(String(rawTicketCost).replace(',', '.'));
                    if (!isFinite(tc)) {
                        // hier wirklich Fehler, weil ein konfigurierter Wert ungültig ist
                        throw new Error('Invalid shippingcosts value in Cart.ticketFormat.shippingcosts: ' + rawTicketCost);
                    }
                    ticketCost = tc;
                }
            }

            var rawExpenses = item.expenses;
            if (rawExpenses == null || rawExpenses === '') {
                throw new Error('Missing expenses value in ShippingMethod.expenses');
            }

            var exp = parseFloat(String(rawExpenses).replace(',', '.'));
            if (!isFinite(exp)) {
                throw new Error('Invalid expenses value in ShippingMethod.expenses: ' + rawExpenses);
            }

            return ticketCost + exp;
        },

        getShippingMethodByID: function (id) {
            id = parseInt(id);
            for (var k in this.methods) {
                if (!this.methods.hasOwnProperty(k)) {
                    continue;
                }
                var shippingMethod = this.methods[ k ];
                if (parseInt(shippingMethod.id) === id) {
                    return shippingMethod;
                }
            }
            return undefined;
        },

        validate: function (shippingMethod) {
            if (!shippingMethod || !shippingMethod.id) {
                return false;
            }

            for (var key in this.methods) {
                if (!this.methods.hasOwnProperty(key)) {
                    continue;
                }

                if (parseInt(this.methods[ key ].id) === parseInt(shippingMethod.id)) {
                    return true;
                }
            }
            return false;
        }
    };
};

export default ShippingMethodService;
